export default __webpack_public_path__ + "static/media/loader.adc360ec.svg";